import React, {useState} from "react";
import { useSelector } from "react-redux";
import styled from "styled-components";
import { useDispatch } from "react-redux";
import moment from "moment";
import { MdOutlineMoreHoriz } from "react-icons/md";
import { setSelectRentalCar } from "../../features/ilanlar/ilanlarSlice";
import { showModal } from "../../features/modal/modalSlice";


const Container = styled.div`
  width: 100%;
  margin-block: 10px;
  background-color: ${({ theme }) => theme.secondaryBgColor};
  .container {
    width: 100%;

    .content {
      width: 100%;
      padding: 15px 10px;
      border-radius: 10px;
      margin: 10px 0px 0px 0px !important;
      position: relative;
      background-color: var(--color-light);
      .row {
        width: 100%;
        display: grid;
        grid-template-columns:  1fr 1fr 1fr 1fr;
        align-items: center;
        justify-content: center;
        
        .col {
          display: flex;
          flex-direction: column;
          gap: 5;
          text-align: center;
          margin-block: 20px;
          .title{
            font-size: var(--font-size-sm);
            font-weight: var(--font-weight-lg);
          }
          .text{
            font-size: var(--font-size-xs);
            font-weight: var(--font-weight-sm);
          }
        }
      }
      .more{
        position: absolute;
        right: 10px;
        cursor: pointer;
        font-size: 20px;
      }
      .detail{
        position: absolute;
        top: 45%;
        right: 40px;
        background-color: white;
        padding: 10px;
        border-radius: 10px;
        display: flex;
        flex-direction: column;
        gap: 5px;
        cursor: pointer;
        font-size: var(--font-size-sm);
        font-weight: var(--font-weight-md);
        color: var(--color-main);
        
      }
    }
  }

  @media (max-width: 650px){
    .row {
      grid-template-columns:  1fr 1fr !important;
    }
  }
`;

const KiralikAracContainerMobile = ({ data }) => {
  const { theme } = useSelector((state) => state.layout);
  const dispatch = useDispatch();

  return (
    <Container theme={theme}>
      <div className="container">
        <div className="content">
          <div className="row">
            <div className="col">
              <p className="title">Kayıt Tarihi</p>
              <p className="text">{moment(data?.createdAt).format('L')}</p>
            </div>
            <div className="col">
              <p className="title">Araç Türü</p>
              <p className="text">{data?.vehicleType}</p>
            </div>
            <div className="col">
              <p className="title">Kasa Tipi</p>
              <p className="text">{data?.bodyType}</p>
            </div>
            <div className="col">
              <p className="title">Çalışılmak İstenen Güzergah</p>
              <p className="text">{data?.workRoute}</p>
            </div>
            <div className="col">
              <p className="title">Talep Edilen Yakıt Yüzdesi</p>
              <p className="text">{data?.fuelPercentage}</p>
            </div>
            <div className="col">
              <p className="title">Talep Edilen Kira Bedeli</p>
              <p className="text">{data?.rentalPrice}</p>
            </div>
            <div className="col">
              <p className="title">İlan İçin Aranacak Telefon</p>
              <p className="text">{data?.contactNumber}</p>
            </div>
            {/* <div className="col">
              <p className="title">İlani Kaydeden Kullanıcı Telefonu</p>
              <p className="text">{data?.advertiserPhoneNumber}</p>
            </div> */}
            
            {/* <div onClick={(e)=> {toggleMore(data); e.stopPropagation(e) }} className="more"><MdOutlineMoreHoriz/></div>
            {isMoreActive && 
              <div className="detail">
                <p onClick={() => {dispatch(setSelectRentalCar(data)); dispatch(showModal("advertReasonForDelete"))}}  className="delete">İlanı Sil</p> 
                { data?.advertStatus === "Arşivde" && <p onClick={() =>{ dispatch(setSelectRentalCar(data)); dispatch(showModal("advertRentalCarUpdate"))}}>İlanı Güncelle</p> }
              </div> 
            } */}
          </div>
        </div>
      </div>
    </Container>
  );
};

export default KiralikAracContainerMobile;
